var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication / Chat_Circle_Dots"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7419 16.5015C12.6406 17.1366 11.3629 17.5 10.0003 17.5C5.85816 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 11.3626 17.1366 12.6403 16.5015 13.7416L16.499 13.7458C16.4379 13.8518 16.4071 13.9052 16.3932 13.9557C16.38 14.0033 16.3763 14.0462 16.3797 14.0955C16.3833 14.1484 16.4012 14.2034 16.4378 14.3132L17.0785 16.2352L17.0793 16.2377C17.2144 16.6433 17.282 16.846 17.2338 16.9811C17.1918 17.0989 17.0986 17.1919 16.9808 17.2339C16.846 17.282 16.6441 17.2147 16.2404 17.0801L16.2354 17.0783L14.3133 16.4376C14.2039 16.4011 14.1482 16.3826 14.0953 16.379C14.046 16.3756 14.0035 16.3801 13.9559 16.3932C13.9053 16.4072 13.8518 16.4381 13.7453 16.4995L13.7419 16.5015Z",
    stroke: "#B4B4C4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCircle);
export default __webpack_public_path__ + "static/media/chat_circle.d74b558af730f3771bd695cc5563d62b.svg";
export { ForwardRef as ReactComponent };